export const REACTORS_ALLOWED_ORG_UUID = '3150ad5c-4557-11ef-8e5b-0252cda442b1';

export const isReactorsOrg = (
  organization?: {
    OrgUUID?: string;
    uuid?: string;
    orguuid?: string;
  } | null
): boolean => {
  if (!organization) {
    return false;
  }
  const orgId = (
    organization.OrgUUID ||
    organization.uuid ||
    organization.orguuid ||
    ''
  ).toLowerCase();
  return orgId === REACTORS_ALLOWED_ORG_UUID;
};
